import { useMutation, useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

interface TokenDetails {
  accessToken: string;
  expirationDate: Date;
  alias: string;
}

const fetchExternalDashboardsAccessToken = async (alias: string) => {
  const { data } = await apiInputService.get("/auth/alias", {
    params: { alias },
  });
  return data as TokenDetails;
};

export const useExternalDashboardsAccessToken = (
  subscription: string,
  options?: any
) => {
  return useMutation(fetchExternalDashboardsAccessToken, {
    ...options,
    enabled: !!subscription,
    staleTime: Infinity,
  });
};
